// @flow

import React, { Component } from 'react';
import styler from 'react-styling';
import _ from 'lodash';
import moment from 'moment';
import { observer } from 'mobx-react';
import { Col, Row } from 'react-bootstrap/lib';

import { EventModal, ContactAvatar } from '../index';
import { uiStateStoreInstance } from '../../Stores/UIStateStore';
import { convertEvent } from '../../libs/Extract';
import { isAllDayInRange } from '../../libs/Event';

const style = styler `  
  ListItem
    cursor: pointer
    background-color: #F5F5F5
    color: #666
    white-space: nowrap
    width: 100%
    display: inline-block
    float: left
    padding: 15px 0
    margin: 0
    border-bottom: 1px solid #ECECEC

  ListItemTitle
    text-decoration: none
    color: inherit
    overflow: hidden
    display: flex
    align-items: center
    &Subject
      margin-bottom: 3px
      font-weight: bold

  Attendants
    display: flex
    margin-bottom: 10px
    margin-top: 10px
`;
type Props = {
  showEventModal: Function,
  languagedata: Object,
  date: any,
  calendarView: string,
};

@observer
class EventTable extends Component {
  state: {
    eventSelected: Object,
    modalShowEvent: boolean,
  } = {
    eventSelected: {},
    modalShowEvent: false,
  }

  props: Props

  _showEventModal = (event: MeetingEvent) => {
    const eventCopy = convertEvent(event);
    this.setState({ eventSelected: eventCopy });
    this.setState({ modalShowEvent: true });
  }

  _closeEventModal = () => {
    this.setState({ modalShowEvent: false });
  }

  _renderNoEvents = () => (
    <p style={{ padding: '15px 0 15px 12px' }}>{this.props.languagedata.no_events}</p>
  );

  _renderEventsForDay = (attendeesArr: Array<any>, event: Object) => (
    <Row style={style.ListItem} onClick={() => this._showEventModal(event)}>
      {event.isAllDay ? <Col xs={3} sm={3} md={3} lg={2}>{this.props.languagedata.all_day}</Col> : <Col xs={3} sm={3} md={3} lg={2}>{moment.unix(event.startDate).format('HH:mm')} - {moment.unix(event.endDate).format('HH:mm')}</Col>}
      <Col xs={9} sm={9} md={9} lg={4}>
        <a style={style.ListItemTitle.Subject}>{event.subject}</a><span style={style.ListItemTitle}>{event.location.displayName}</span>
      </Col>
      <Col xs={3} sm={3} md={3} lg={0} />
      <Col xs={9} sm={9} md={9} lg={6}>
        {_.uniqBy(attendeesArr, 'name').map((attendas, indx) =>
          <div key={indx} style={{ display: 'flex', marginBottom: '10px' }}>
            <ContactAvatar
              imagePath={attendas.email ? `/contacts/photo/${attendas.email}` : null}
              displayName={attendas.name}
              height="30px"
              width="30px"
              textAlign="center"
              margin="0 8px 0 0"
              imgMargin="0 8px 0 0"
            />
            <a style={style.ListItemTitle}>{attendas.name} <br /> </a>
          </div>
        )}
      </Col>
    </Row>
  );

  _renderEventsForWeek = (attendeesArr: Array<any>, event: Object) => (
    <Row style={style.ListItem} onClick={() => this._showEventModal(event)}>
      {event.isAllDay ? <Col xs={3} style={style.Time}>{this.props.languagedata.all_day}</Col> : <Col xs={3} style={style.Time}>{moment.unix(event.startDate).format('HH:mm')} - {moment.unix(event.endDate).format('HH:mm')}</Col>}
      <Col xs={9} style={{ paddingLeft: '40px' }}>
        <a style={style.ListItemTitle.Subject}>{event.subject}</a><span style={style.ListItemTitle}>{event.location.displayName}</span>
        {_.uniqBy(attendeesArr, 'name').map((attendas, indx) =>
          <div key={indx} style={style.Attendants}>
            <ContactAvatar
              imagePath={attendas.email ? `/contacts/photo/${attendas.email}` : null}
              displayName={attendas.name}
              height="30px"
              width="30px"
              textAlign="center"
              margin="0 8px 0 0"
              imgMargin="0 8px 0 0"
            />
            <a style={style.ListItemTitle}>{attendas.name} <br /> </a>
          </div>
        )}
      </Col>
    </Row>
  );
  render() {
    const { calendarView } = this.props;
    const endOfDay = moment(this.props.date).endOf('day').unix();
    const startOfDay = moment(this.props.date).startOf('day').unix();
    let filteredOrderedEventsArr = uiStateStoreInstance.events.slice();
    const selectedListEmails = uiStateStoreInstance.emails;
    // remove cancelled AND remove if event with owner that not selected in the contact list
    filteredOrderedEventsArr = _.filter(filteredOrderedEventsArr, event => !event.isCancelled && selectedListEmails.slice().includes(event.owner.email) && ((event.endDate < endOfDay && event.startDate > startOfDay) || isAllDayInRange(event, this.props.date)));
    filteredOrderedEventsArr = _.unionBy(filteredOrderedEventsArr, 'iCalUId');
    filteredOrderedEventsArr = _.orderBy(filteredOrderedEventsArr, ['startDate'], ['asc']);
    return (
      <div style={{ background: '#F5F5F5' }}>
        {filteredOrderedEventsArr.length !== 0 ? filteredOrderedEventsArr.map((event) => {
          const eventAttendees = event.requiredAttendees;
          const eventOptionalAttendees = event.optionalAttendees;
          const attendeesArr = [];
          // if Private event show who fetched it
          if (selectedListEmails.includes(event.owner.email)) {
            attendeesArr.push({ name: event.owner.displayName, email: event.owner.email });
          }

          eventAttendees.forEach(attendas => {
            if (selectedListEmails.includes(attendas.email)) attendeesArr.push({ name: attendas.displayName, email: attendas.email });
          });
          eventOptionalAttendees.forEach(attendas => {
            if (selectedListEmails.includes(attendas.email)) attendeesArr.push({ name: attendas.displayName, email: attendas.email });
          });
          return (
            <div>
              {calendarView === 'listDay' ? this._renderEventsForDay(attendeesArr, event) : this._renderEventsForWeek(attendeesArr, event)}
            </div>
          );
        })
     : this._renderNoEvents() }
        { this.state.modalShowEvent ? (
          <EventModal
            show={this.state.modalShowEvent}
            close={this._closeEventModal}
            event={this.state.eventSelected}
            languagedata={this.props.languagedata}
          />
        ) : (null)}
      </div>
    );
  }
}
export default EventTable;



// WEBPACK FOOTER //
// ./src/js/Components/Calendar/EventTable.js